import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { TextsCollection } from '../interfaces/texts/txts-collection.interface';

@Injectable({
  providedIn: 'root'
})
export class TextsDataService {
  private jsonText: string = '../../assets/data/texts.json';
  private textsSubject: BehaviorSubject<TextsCollection | null> = new BehaviorSubject<TextsCollection | null>(null); 
  public texts$: Observable<TextsCollection | null> = this.textsSubject.asObservable(); 

  constructor(private http: HttpClient) {
    this.loadTextData();
  }

  private loadTextData() {
    this.http.get<TextsCollection>(this.jsonText).pipe( 
      tap(data => this.textsSubject.next(data))
    ).subscribe();
  }

  getTextData(): Observable<TextsCollection | null> { 
    return this.texts$;
  }
}
